// @flow

import * as React from 'react'
import fengPerf from 'feng-performance'

if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
  fengPerf.PerfClient.setEnv(fengPerf.EnvType.Beta)
}

export default function () {
  return function (InnerComp: React.ComponentType<*>) {
    class LoadTime extends React.Component<*, *> {
      addSendTime () {
        setTimeout(() => {
          fengPerf.PerfClient.sendWebLoadTime()
        }, 0)
      }

      componentWillMount () {
        window.addEventListener('load', this.addSendTime)
      }

      componentWillUnmount () {
        window.removeEventListener('load', this.addSendTime)
      }

      render () {
        return <InnerComp />
      }
    }
    return LoadTime
  }
}



// WEBPACK FOOTER //
// ./src/frame/core/analysis/loadTime.js